import {entityCardsFeatureKey, selectAll, selectEntities} from './entity-card.reducer';
import {selectors} from '~utils/ngrx-util';

const {
  entitySelectAll,
  entitySelectEntities,
  entitySelectById,
} = selectors(entityCardsFeatureKey, {selectAll, selectEntities});

export const entityCardSelectAll = entitySelectAll;
export const entityCardSelectEntities = entitySelectEntities;
export const entityCardSelectById = entitySelectById;
